import { useState, useEffect } from 'react';
import axios from 'axios';
import { backRemu } from '../urlApi';
import Swal from 'sweetalert2';



export const useSolicitudes = () => {
  const [solicitudes, setSolicitudes] = useState([]);
  const [existeP, setExisteP] = useState(false)
  const [loading, setLoading] = useState(false);

  const fetchSolicitudes = async () => {

    setLoading(true)

    try {
      const response = await axios.get(`${backRemu}vacaciones/solicitudes/${localStorage.getItem('conid')}`);
 
      setSolicitudes(response.data);
      setLoading(false)

    } catch (error) {
      console.error("Error al obtener solicitudes:", error);
      setLoading(false)
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {

    fetchSolicitudes();

    
  }, []);


  const solicitarVacaciones = async (solicitud) => {

    console.log(solicitud, 'A SOLICITAR')
    // return

        try {

           const response = await axios.post(`${backRemu}vacaciones/solicitudes/crear`, 
            solicitud
           );

           console.log(response.data)

           await  fetchSolicitudes()
          
        } catch (error) {
          console.log(error,'error')
        }

  }


  const reenviarSolicitud = async (id) => {

        try {

          await axios.get(`${backRemu}vacaciones/reenviar-mail-solicitud/${id}` );

          Swal.fire('Solicitud reenviada al correo indicado')
        
      } catch (error) {
        console.log(error,'error')
      }

  }


  return { solicitudes, loading, existeP,fetchSolicitudes, setSolicitudes,solicitarVacaciones, reenviarSolicitud };
};
